import React from 'react';
import { Button } from '@mui/material';

import MLLoader from 'components/common/Loader/Loader';
import MLCustomIcon from 'components/common/CustomIcon';

import './Button.module.scss';

function MLButton({
  btnText = 'Button',
  btnVariant = 'contained',
  btnColor = 'primary',
  classList = '',
  btnDisable = false,
  btnSize = 'large',
  onClickFunc,
  onMouseDownFunc,
  onMouseUpFunc,
  startIcon = false,
  endIcon = false,
  iconName = '',
  iconWidth,
  iconHeight,
  iconFill = '',
  iconStroke = 'var(--Black)',
  isLoading = false,
  btnIconText = '',
  icon = null,
}) {
  return (
    <Button
      // disableRipple
      size={btnSize}
      variant={btnVariant}
      color={btnColor}
      className={`btn-wrap ${classList} ${
        startIcon || endIcon || icon ? 'btn-icon' : ''
      }`}
      disabled={btnDisable || isLoading}
      onClick={onClickFunc}
      onMouseDown={onMouseDownFunc}
      onMouseUp={onMouseUpFunc}
      startIcon={
        icon ||
        (startIcon ? (
          <MLCustomIcon
            iconName={iconName}
            width={iconWidth}
            height={iconHeight}
            stroke={iconStroke}
            fill={iconFill}
            iconText={btnIconText}
          />
        ) : (
          ''
        ))
      }
      endIcon={
        endIcon ? (
          <MLCustomIcon
            iconName={iconName}
            width={iconWidth}
            height={iconHeight}
            stroke={iconStroke}
            fill={iconFill}
          />
        ) : (
          ''
        )
      }
    >
      <div className="flex gap-2">
        {isLoading && <MLLoader loaderColor="var(--White)" loaderSize="15px" />}
        {btnText}
      </div>
    </Button>
  );
}

export default MLButton;
